import { ToggleButton } from '..'

type TNotificationSettingsItem = {
  readonly title: string
  readonly state?: boolean
  readonly onClick: (newState: boolean) => void
}
export default function NotificationSettingsItem({
  title,
  state = false,
  onClick,
}: TNotificationSettingsItem) {
  return (
    <div className='flex flex-col gap-4'>
      <p className='text-xs font-semibold'>{title}</p>
      <div className='flex flex-row items-center justify-between'>
        <p className='text-xs text-pop-grey-500'>{state ? 'On' : 'Off'}</p>
        <ToggleButton state={state} onToggleButton={onClick} data-testid='toggle-button' />
      </div>
    </div>
  )
}
